import { render, staticRenderFns } from "./AudioVisual.vue?vue&type=template&id=0567448c&"
import script from "./AudioVisual.vue?vue&type=script&lang=ts&"
export * from "./AudioVisual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports